import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import OAuthGrant from '../views/OAuthGrant'
import Motor from "@/views/Motor";
import Quote from "@/views/Quote";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/motor",
    name: "Motor",
    component: Motor
  },
  {
    path: "/motor/quote",
    name: "Quote",
    component: Quote
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/quote",
    name: "Form",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/Form.vue")
  },
  {
    path: "/grant-oauth",
    name: "GrantOAuth",
    component: OAuthGrant
  }
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

export default router;
